import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const ACTIVE_STUDENT_SERVICE = new InjectionToken<IActiveStudentService>(
	'ACTIVE_STUDENT_SERVICE',
);

export interface IActiveStudentService {
	getActiveStudent$(): Observable<number>;
	setActiveStudent$(studentId: number): Observable<number>;
	getAvailableStudents$(): Observable<[id: number, name?: string][]>;
}
